module.exports = __webpack_public_path__ + "img/news-central-grey.43213893.jpg";